import { SearchInput } from "~/components/controls"
import { ItemsCount } from "./ItemsCount"
import { Spinner } from "~/components/ui"
import { useStoreContext } from "../../contexts/store.context"
import { FiltersToggle } from "./FiltersToggle"
import { OrderBy } from "./OrderBy"
import { ViewToggle } from "./ViewToggle"

/**
 * Every child is a direct, independently wrappable item, and none of them is pinned with
 * `ml-auto`.
 *
 * That is load-bearing at 375px. The toolbar wraps, and the sort (207px), the view toggle (90px)
 * and the count (107px) with two 16px gaps want 436px in the 366px a phone leaves — so anything
 * that groups them, or pushes one to the far end of its line, turns "wrap onto the next line" into
 * 23px of horizontal page scroll. Grouping the count and spinner behind an `ml-auto` did exactly
 * that, and the grid view had been hiding it: its header sits in a `place-content-center` grid
 * cell capped at 320px, so those three had already been forced onto separate lines.
 */
export const Toolbar = () => {
    const { isFetching, searchTerm, setSearchTerm } = useStoreContext()
    return <div className="flex flex-row flex-wrap items-center gap-4 text-sm">
        <FiltersToggle />
        {/* `SearchInput` is `flex-1` with an `auto` min-width, so it cannot shrink past its own
            content. The wrapper is what gives it something to shrink to. */}
        <div className="flex flex-1 min-w-0"><SearchInput value={searchTerm} onChange={setSearchTerm} /></div>
        <OrderBy />
        <ViewToggle />
        <ItemsCount />
        <Spinner visible={isFetching} />
    </div>
}
